import React from 'react';

import {
  List,
} from '@mui/material';

import type { SleepJson } from '@/types/domain/sleep/entities/sleepEntity';

import CustomListItem from '@/components/CustomListItem';
import { toStringDateTimeDisplay } from '@/utils/date';

const SleepInfo: React.FC<{
  /** データ */
  data: SleepJson,
}> = ({ data }) => {
  const {
    measureDateTime,
  } = data.data;
  return (
    <List>
      <CustomListItem
        name="日時"
        content={toStringDateTimeDisplay(new Date(measureDateTime), true)}
      />
    </List>
  );
};

export default SleepInfo;
